import './tab_view.js.coffee'
Customer.Tabs ||= {}

class Customer.Tabs.BasicTabView extends Customer.Tabs.TabView
  className: 'customer-tab-invisible'
  template: JST["backbone/templates/customer/tabs/basic_tab"]

  events:
    'click .tab': 'onClickTab'

  isVisible: ->
    false

  startTabRefresh: () ->


  finishTabRefresh: () ->
